var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFailAnswer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1973 8.23322V4.08263H14.4937C14.0644 4.08408 13.6376 4.01851 13.2291 3.88836L12.3923 3.61938C11.74 3.41258 11.0592 3.30671 10.3741 3.30556H3.87654C3.63591 3.3056 3.40404 3.39464 3.22669 3.55509C3.04934 3.71555 2.9394 3.93577 2.91856 4.17229L2.00603 11.0202C1.99355 11.1087 2.0005 11.1989 2.02639 11.2845C2.05229 11.3702 2.09654 11.4493 2.15614 11.5166C2.21574 11.5839 2.28931 11.6378 2.37185 11.6746C2.4544 11.7115 2.54399 11.7303 2.63458 11.73H6.87919C6.99201 11.731 7.09987 11.7759 7.17929 11.855C7.25872 11.9341 7.30328 12.0409 7.30328 12.1522V15.324C7.30327 15.4386 7.32621 15.5521 7.37079 15.658C7.41536 15.7638 7.48068 15.8599 7.56301 15.9408C7.64534 16.0217 7.74304 16.0857 7.85052 16.1293C7.95799 16.1728 8.07313 16.1949 8.1893 16.1944H9.64708L11.3926 12.2269C11.5103 11.9593 11.6807 11.7175 11.8939 11.5155C12.1071 11.3134 12.3589 11.1553 12.6346 11.0501L13.3502 10.7774C13.7469 10.6286 14.1678 10.5527 14.5922 10.5532H18",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFailAnswer);
export default ForwardRef;